








import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { mainSiteLink } from '@/utils/plugins/links'

interface Data {}

interface Methods {}

interface Computed {}

interface Props {
  title: string
  description: string
}

export default Vue.extend({
  name: 'NoFlatPlug',
  props: {
    emoji: {
      type: String,
      default: () => '👀'
    },
    title: {
      type: String,
      default: () => ''
    },
    description: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    viewFlatsLink () {
      return `${mainSiteLink}/apartments`
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
